import { useEffect, useState } from 'react';
import { useScrollHandler, useNavigationHandlers } from '@src/shared/hooks';

export const useTermsController = () => {
  const [isFixed, setIsFixed] = useState(true);
  const { scrollToTop } = useScrollHandler();
  const { toHome } = useNavigationHandlers();

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.offsetHeight;

      if (documentHeight - scrollPosition > 296) {
        setIsFixed(true);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.offsetHeight;

      if (scrollPosition >= documentHeight - 4) {
        setIsFixed(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { isFixed, toHome };
};
